import * as React from "react";
import { ThemeIcon, Text, Button, Stack, Center } from "@mantine/core";
import { AlertCircle, RefreshCw } from "lucide-react";

interface ErrorStateProps {
    title?: string;
    message?: string;
    icon?: React.ReactNode;
    actionLabel?: string;
    onAction?: () => void;
    showAction?: boolean;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
    title = "Something went wrong",
    message = "We encountered an unexpected error. Please try again.",
    icon = <AlertCircle size={32} />,
    actionLabel = "Retry",
    onAction,
    showAction = true,
}) => {
    return (
        <Center py={60} style={{ minHeight: "300px", width: "100%" }}>
            <Stack align="center" gap="xs" style={{ textAlign: "center", maxWidth: 400 }}>
                <ThemeIcon size={60} radius="xl" color="red" variant="light" mb="md">
                    {icon}
                </ThemeIcon>
                <Text size="xl" fw={600} c="red.7">
                    {title}
                </Text>
                <Text c="dimmed" size="sm">
                    {message}
                </Text>
                {showAction && onAction && (
                    <Button
                        mt="lg"
                        onClick={onAction}
                        variant="light"
                        color="red"
                        leftSection={<RefreshCw size={16} />}
                    >
                        {actionLabel}
                    </Button>
                )}
            </Stack>
        </Center>
    );
};
